import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0b23820&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f0b23820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b23820",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlytippingReportHeader: require('/opt/atlassian/pipelines/agent/build/components/flytipping/ReportHeader.vue').default,FlytippingReportThanks: require('/opt/atlassian/pipelines/agent/build/components/flytipping/ReportThanks.vue').default,FlytippingReportEmailVerify: require('/opt/atlassian/pipelines/agent/build/components/flytipping/ReportEmailVerify.vue').default,CommentsSiteComments: require('/opt/atlassian/pipelines/agent/build/components/comments/SiteComments.vue').default,GroupItem: require('/opt/atlassian/pipelines/agent/build/components/group/GroupItem.vue').default,FlytippingReport: require('/opt/atlassian/pipelines/agent/build/components/flytipping/Report.vue').default,GridWrapper: require('/opt/atlassian/pipelines/agent/build/components/GridWrapper.vue').default,BottomSheet: require('/opt/atlassian/pipelines/agent/build/components/BottomSheet.vue').default,FlytippingReportOwnerMenu: require('/opt/atlassian/pipelines/agent/build/components/flytipping/ReportOwnerMenu.vue').default})
